import axios from "axios";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "deadlines",
  components: {},
  props: [],
  data() {
    return {
      toCreate: { points: {} },
      toEdit: {
        points: {},
      },
      selectedItem: {},
      creating: true,
      fields: [
        "title",
        "startDate",
        "endDate",
        "points",
        {
          key: "actions",
          label: "Actions",
        },
      ],
    };
  },
  computed: {
    deadlines() {
      return this.$store.getters.getDeadlines;
    },
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Backend" },
      { title: "Content", route: "projects" },
      { title: "Manage Deadlines" },
    ]);
  },
  methods: {
    saveDeadlineResult(i) {
      let users = this.$store.getters.getUsers;
      users.forEach((element) => {
        let level = "lvl0";
        if (element.points.total >= i.points.lvl1) {
          level = "lvl1";
        }
        if (element.points.total >= i.points.lvl2) {
          level = "lvl2";
        }
        element.deadlines.push({
          deadline: i._id,
          level: level,
          score: element.points.total,
        });
        console.log(element.deadlines);
        axios.put("users/" + element._id, element).then(() => {
          i.isActive = false;
          axios.put("deadlines/" + i._id, i).then((response) => {
            console.log(response);
          });
        });
      });
    },
    createItem(evt) {
      evt.preventDefault();
      axios.post("deadlines", this.toCreate).then((response) => {
        console.log(response);
        this.$store.dispatch("fetchDeadlines");
        this.toCreate = {};
      });
    },
    deleteItem(id) {
      axios.delete("deadlines/" + id).then((response) => {
        console.log(response);
        this.$store.dispatch("fetchDeadlines");
      });
    },
    editItem(id, evt) {
      evt.preventDefault();
      axios.put("deadlines/" + id, this.toEdit).then((response) => {
        console.log(response);
        this.$store.dispatch("fetchDeadlines");
      });
      this.creating = true;
    },
    viewItem(item) {
      this.toEdit = item;
      this.creating = false;
    },
    changeToCreate() {
      this.toEdit = null;
      this.creating = true;
    },
  },
};
